<script lang="ts">
    import {  TabContent , TabPane} from "sveltestrap";
    import CheckLayout from "./CheckLayout.svelte";
    import SidebarCusmizer from "./SidebarCusmizer.svelte";
    import ColorPicker from "./ColorPicker.svelte";
    import { Livecustomizer } from "../../utils/Constant/Constant";
    import {tablist,tabId} from "../../store"
    let setTabId:string
    // for customizer close
    const handleCustomizer = () => {
        tablist.update(value => value = false)
    }
    tabId.subscribe((value)=>{
        setTabId = value
    })
</script>
<TabContent id="c-pills-tabContent">
    <div class="customizer-header">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <i class="icofont-close icon-close" on:click={handleCustomizer}></i>
        <h5>{Livecustomizer}</h5>
        <p  class= 'mb-0' >Customize &amp; Preview Real Time</p>
    </div>
    <div class="customizer-body custom-scrollbar tab-content">
        <TabPane id="check-layout" class={setTabId == "check-layout" ? "active" : ""} >
            <CheckLayout />
        </TabPane>
        <TabPane id="sidebar-type" class={setTabId == "sidebar-type" ? "active" : ""} >
            <SidebarCusmizer />
        </TabPane>
        <TabPane id="color-picker" class={setTabId == "color-picker" ? "active" : ""}>
            <ColorPicker />
        </TabPane>
    </div>
</TabContent>